import cn from "classnames";
import { forwardRef } from "react";
import styles from "./Button.module.css";
import type { ButtonProps } from "./types";

const Button = forwardRef<HTMLButtonElement & HTMLAnchorElement, ButtonProps>(function Button(
    {
        variant = "primary",
        size = "m",
        href,
        disabled,
        className,
        fullWidth,
        children,
        target,
        type,
        ...props
    },
    ref,
) {
    const buttonClassname = cn(
        styles.button,
        styles[variant],
        styles[size],
        fullWidth && styles.fullWidth,
        className,
    );

    if (href) {
        return (
            <a
                className={buttonClassname}
                ref={ref}
                href={href}
                target={target}
                rel="noopener noreferrer"
                {...props}
            >
                {children}
            </a>
        );
    }

    return (
        <button className={buttonClassname} ref={ref} disabled={disabled} type={type} {...props}>
            {children}
        </button>
    );
});

export { Button };
